import { Flex } from "@chakra-ui/react";
import VaultHeader from "@components/V2/Vault/Common/VaultHeader";
import { useXgUsdVault, useXgUsdDeposit } from "./xgUsdHooks";
import VaultDWB from "@components/V2/Vault/Common/VaultDWB";
const CryptaniumVault = () => {
  const { vaultHeaderData, isSanctioned } = useXgUsdVault();
  const depositLogic = useXgUsdDeposit();

  return (
    <>
      <Flex
        direction={"column"}
        alignItems={"center"}
        gap="20px"
        // p="16px"
        maxW="1279px"
        w="100%"
        mx="auto"
        pointerEvents={isSanctioned ? "none" : "auto"}
        opacity={isSanctioned ? 0.5 : 1}
      >
        <VaultHeader
          isLoadingAPYData={vaultHeaderData.isLoadingAPYData}
          isLoadingTotalStaked={vaultHeaderData.isLoadingTotalStaked}
          totalStaked={vaultHeaderData.totalStaked}
          totalStakedEth={vaultHeaderData.totalStakedEth}
          apyValue={vaultHeaderData.apyValue}
          apyLabel={vaultHeaderData.apyLabel}
          totalStakedLabel={vaultHeaderData.totalStakedLabel}
          title={vaultHeaderData.title}
          logo={vaultHeaderData.logo}
          auditedUrl={vaultHeaderData.auditedUrl}
        />

        <VaultDWB
          availableTabs={["deposit"]} // CryptaniumVault only supports deposit
          depositProps={{
            vaultTokenSymbol: "xgUSD",
            inputTokenSymbol:
              (depositLogic as any)?.selectedERC20Vault || "USDT",
            inputTokenBalance: (depositLogic as any)?.tokenBalance || 0,
            vaultTokenBalance: (depositLogic as any)?.xTokenVaultBalance || 0,
            convertedAmount: (depositLogic as any)?.convertedAmount || "0",
            exchangeRateDisplay: (depositLogic as any)?.valueInUsdt
              ? `1 xgUSD = ${(depositLogic as any).valueInUsdt} USDT`
              : undefined,
            isConnected: (depositLogic as any)?.isConnected || false,
            isApproved: (depositLogic as any)?.isApproved || false,
            isSupportedChain:
              (depositLogic as any)?.isCryptaniumVaultSupportedChain !== false,
            onDeposit: (amount?: string) =>
              (depositLogic as any)?.handleClick?.(amount),
            onApprove: (amount?: string) =>
              (depositLogic as any)?.handleClick?.(amount),
            onAmountChange: (depositLogic as any)?.handleChange,
            onTokenSelect: (depositLogic as any)?.handleTokenSelect,
            vaultType: "cryptanium",
          }}
        />

        {/* <Portfolio
          config={portfolioConfig}
          constants={constants}
          vaultType="cryptanium"
          xTokenSymbol="xgUSD"
          asset="xgusd"
        />

        <Flex width="100%" maxW="736px">
          <DefiPartnerships asset="xgusd" />
        </Flex> */}
      </Flex>
    </>
  );
};

export default CryptaniumVault;
